export default __webpack_public_path__ + "static/media/Lava.da71364b.jpg";